'use client';

import { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import ScrollReveal from '@/components/ScrollReveal';

const testimonials = [
{
  id: 'test-1',
  quote:
  'The Luminous Veil Serum completely transformed my skin in 6 weeks. My hyperpigmentation faded by about 70% and I get compliments on my glow every single day.',
  name: 'Priya Sharma',
  role: 'Beauty Editor, New York',
  avatar: 'https://img.rocket.new/generatedImages/rocket_gen_img_1c6a212c5-1769686185205.png',
  rating: 5,
  product: 'Luminous Veil Serum',
  result: 'Hyperpigmentation faded 70% in 6 weeks'
},
{
  id: 'test-2',
  quote:
  "Finally a luxury brand that actually delivers results. The Midnight Repair Cream has given me the plumpest, most hydrated skin I've had since my 20s. At 42, that's saying something.",
  name: 'Jennifer Walsh',
  role: 'Dermatology Nurse, Chicago',
  avatar: 'https://img.rocket.new/generatedImages/rocket_gen_img_1321111d7-1765378597121.png',
  rating: 5,
  product: 'Midnight Repair Cream',
  result: 'Visibly younger skin after 4 weeks'
},
{
  id: 'test-3',
  quote:
  "I\'ve tried every luxury lipstick on the market. The Velvet Matte is the first one that actually stays on through a full workday without feeling dry. The shade range is stunning.",
  name: 'Amara Okafor',
  role: 'Creative Director, Los Angeles',
  avatar: 'https://img.rocket.new/generatedImages/rocket_gen_img_1591964c1-1767518921170.png',
  rating: 5,
  product: 'Velvet Matte Lipstick',
  result: 'All-day wear, no drying effect'
},
{
  id: 'test-4',
  quote:
  "As someone with sensitive, rosacea-prone skin I was nervous to try new products. The Rose Petal Oil is the most calming thing I've ever used. My redness reduced noticeably in two weeks.",
  name: 'Sarah Kim',
  role: 'Yoga Instructor, San Francisco',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1b4abacd5-1771484642256.png",
  rating: 5,
  product: 'Rose Petal Radiance Oil',
  result: 'Redness reduced, skin calmed in 2 weeks'
}];


export default function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  const prev = () => setActiveIndex((i) => i === 0 ? testimonials?.length - 1 : i - 1);
  const next = () => setActiveIndex((i) => i === testimonials?.length - 1 ? 0 : i + 1);

  const active = testimonials?.[activeIndex];

  return (
    <section className="section-padding bg-[#F0EBE0] relative overflow-hidden">
      {/* Background Decorative */}
      <div
        className="absolute top-0 right-0 w-1/3 h-full pointer-events-none"
        style={{
          background: 'linear-gradient(to left, rgba(201,169,110,0.05), transparent)'
        }} />
      

      <div className="max-w-8xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <ScrollReveal>
          <div className="flex flex-col md:flex-row items-start md:items-end justify-between mb-16 gap-6">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-px bg-[#C9A96E]" />
                <span className="label-gold">Real Results</span>
              </div>
              <h2
                className="font-fraunces leading-tight text-[#1A1612]"
                style={{ fontSize: 'clamp(2.2rem, 4.5vw, 4rem)', fontWeight: 400 }}>
                
                Skin that
                <br />
                <em className="gradient-gold not-italic">speaks for itself</em>
              </h2>
            </div>
            <div className="flex items-center gap-4">
              <button
                onClick={prev}
                className="w-11 h-11 rounded-full border border-[rgba(26,22,18,0.15)] flex items-center justify-center hover:bg-[#1A1612] hover:text-[#FAF8F3] hover:border-[#1A1612] transition-all"
                aria-label="Previous testimonial">
                
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2">
                  
                  <path d="M15 18l-6-6 6-6" />
                </svg>
              </button>
              <button
                onClick={next}
                className="w-11 h-11 rounded-full border border-[#C9A96E] flex items-center justify-center text-[#C9A96E] hover:bg-[#C9A96E] hover:text-[#1A1612] transition-all"
                aria-label="Next testimonial">
                
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2">
                  
                  <path d="M9 18l6-6-6-6" />
                </svg>
              </button>
            </div>
          </div>
        </ScrollReveal>

        {/* Main Testimonial Display */}
        <div className="grid grid-cols-12 gap-8 items-center">
          {/* Left: Active Testimonial */}
          <div className="col-span-12 lg:col-span-7">
            <ScrollReveal>
              <div
                className="bg-white p-8 lg:p-12 relative overflow-hidden"
                style={{ borderLeft: '3px solid #C9A96E' }}>
                
                {/* Quote mark */}
                <div className="absolute top-6 right-8 font-fraunces text-[120px] leading-none text-[#C9A96E] opacity-10 pointer-events-none select-none">
                  "
                </div>

                {/* Stars */}
                <div className="flex gap-1 mb-6">
                  {[1, 2, 3, 4, 5]?.map((s) =>
                  <span key={s} className="text-[#C9A96E] text-lg">
                      ★
                    </span>
                  )}
                </div>

                {/* Quote */}
                <blockquote
                  className="font-fraunces text-[#1A1612] leading-relaxed mb-8"
                  style={{ fontSize: 'clamp(1.1rem, 2vw, 1.4rem)', fontWeight: 400 }}>
                  
                  &ldquo;{active?.quote}&rdquo;
                </blockquote>

                {/* Result badge */}
                <div
                  className="inline-flex items-center gap-2 mb-8 px-3 py-1.5"
                  style={{
                    background: 'rgba(201,169,110,0.1)',
                    border: '1px solid rgba(201,169,110,0.3)'
                  }}>
                  
                  <span className="text-[#C9A96E] text-xs">✓</span>
                  <span className="text-[11px] font-semibold text-[#8A7E72] tracking-wide">
                    {active?.result}
                  </span>
                </div>

                {/* Author */}
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-[rgba(201,169,110,0.3)]">
                    <AppImage
                      src={active?.avatar}
                      alt={`${active?.name}, LuxeBeauty customer testimonial portrait`}
                      className="w-full h-full object-cover" />
                    
                  </div>
                  <div>
                    <p className="font-semibold text-[14px] text-[#1A1612]">{active?.name}</p>
                    <p className="text-[11px] text-[#8A7E72]">{active?.role}</p>
                  </div>
                  <div className="ml-auto">
                    <p className="text-[10px] font-bold tracking-widest uppercase text-[#C9A96E]">
                      Using
                    </p>
                    <p className="text-[12px] text-[#8A7E72] font-medium">{active?.product}</p>
                  </div>
                </div>

                {/* Bottom gold line */}
                <div
                  className="absolute bottom-0 left-0 h-0.5"
                  style={{
                    width: `${(activeIndex + 1) / testimonials?.length * 100}%`,
                    background: 'linear-gradient(90deg, #C9A96E, #E8D5B0)',
                    transition: 'width 0.5s ease'
                  }} />
                
              </div>
            </ScrollReveal>
          </div>

          {/* Right: Thumbnail List */}
          <div className="col-span-12 lg:col-span-5">
            <ScrollReveal delay={100}>
              <div className="space-y-4">
                {testimonials?.map((t, i) =>
                <button
                  key={t?.id}
                  onClick={() => setActiveIndex(i)}
                  className={`w-full text-left p-4 transition-all duration-400 flex items-center gap-4 ${
                  i === activeIndex ?
                  'bg-white border border-[rgba(201,169,110,0.3)] shadow-sm' :
                  'bg-transparent hover:bg-white/50 border border-transparent'}`
                  }>
                  
                    <div
                    className={`w-10 h-10 rounded-full overflow-hidden flex-shrink-0 border-2 transition-all ${
                    i === activeIndex ? 'border-[#C9A96E]' : 'border-transparent grayscale'}`
                    }>
                    
                      <AppImage
                      src={t?.avatar}
                      alt={`${t?.name} testimonial thumbnail`}
                      className="w-full h-full object-cover" />
                    
                    </div>
                    <div className="flex-1 min-w-0">
                      <p
                      className={`font-semibold text-[13px] transition-colors ${
                      i === activeIndex ? 'text-[#1A1612]' : 'text-[#8A7E72]'}`
                      }>
                      
                        {t?.name}
                      </p>
                      <p className="text-[11px] text-[#B8AFA6] truncate">{t?.product}</p>
                    </div>
                    {i === activeIndex &&
                  <div className="w-1.5 h-1.5 rounded-full bg-[#C9A96E] flex-shrink-0" />
                  }
                  </button>
                )}
              </div>

              {/* Pagination dots */}
              <div className="flex gap-2 mt-6 pl-4">
                {testimonials?.map((_, i) =>
                <button
                  key={`dot-${i}`}
                  onClick={() => setActiveIndex(i)}
                  className={`h-0.5 transition-all duration-300 ${
                  i === activeIndex ? 'w-8 bg-[#C9A96E]' : 'w-4 bg-[#E8D5B0]'}`
                  }
                  aria-label={`Go to testimonial ${i + 1}`} />

                )}
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>);

}